var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"partPopupTable",attrs:{"index":"","columns":_vm.columns,"rows":_vm.resultPopupCommList,"stripe":false,"selection":false,"height":"520px","fit":"fit"}})
}
var staticRenderFns = []

export { render, staticRenderFns }